// @flow

import React, { type Node, useEffect } from 'react';
import { useContentHeaderContext } from 'app/common/react/ui/ContentHeaderContext';
import { useHeaderHeight } from 'app/common/react/components/Header/Context/ContextConsumer';

type Props = {|
  children: Node,
  className?: ?string,
  forwardRef?: (ref: ?HTMLDivElement) => void,
  position?: 'fixed' | 'sticky',
  style?: {},
|};

const ContentHeader = ({ children, className, forwardRef, position, style = {} }: Props) => {
  const { setIsContentHeaderPresent } = useContentHeaderContext();

  useEffect(() => {
    setIsContentHeaderPresent(true);

    return function cleanup() {
      setIsContentHeaderPresent(false);
    };
  }, []);

  const headerHeight = useHeaderHeight();

  return (
    <div
      className={className}
      ref={forwardRef}
      style={{ top: headerHeight, ...(position ? { position } : {}), ...style }}
    >
      {children}
    </div>
  );
};

export default ContentHeader;
